import React, { useEffect, useRef } from "react";
import { SudoButton } from "src/sudokit/components/SudoButton";

interface MenuDeleteConfirmationProps {
  children: React.ReactNode;
  onConfirm: () => void;
  width?: number;
}

export function MenuDeleteConfirmation({ children, onConfirm, width = 200 }: MenuDeleteConfirmationProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    containerRef.current?.querySelector<HTMLElement>('[role="menuitem"]')?.focus();
  }, []);

  return (
    <div ref={containerRef} style={{ width }} className="flex flex-col gap-[10px] text-base leading-[1.3] text-left text-app-grey-0 font-medium p-[14px]">
      <div className="font-bold">Are you sure?</div>
      <div>{children}</div>
      {/* Override the enclosing menu reset, which forces button margins to zero. */}
      <SudoButton
        type="button"
        role="menuitem"
        tabIndex={-1}
        variant="error"
        onClick={onConfirm}
        onKeyDown={(event) => {
          // Focus moves here while Delete's key may still be held. Require a
          // fresh press so key repeat cannot confirm a destructive action.
          if (event.repeat && (event.key === "Enter" || event.key === " ")) {
            event.preventDefault();
          }
        }}
        className="[&&]:mt-[10px] w-fit before:rounded-[10px] before:bg-[color-mix(in_srgb,var(--danger-color)_5%,transparent)]"
      >
        Yes, I&apos;m sure
      </SudoButton>
    </div>
  );
}
